import BASIC from "./basic";

export default {
  ...BASIC,
};
